import { Children, } from "react";



const Each = ({ render, of }) => Children.toArray(of.map((v, i) => render(v, i)));

export default Each;
